import { link } from '@uds/tagmg';
import { Maybe } from 'core';

import { isNilOrEmpty } from './generalUtils';
import { escapeRegExp } from './regex';

/**
 * It checks if a domain name matches exactly the search typed on DST.
 *
 * @param domainName eg: my-domain-name  (it should not include TLD)
 * @param search eg: my-domain-name.com  (this stands for the search text users typed on DST)
 */
export const domainNameMatchWithSearch = (domainName: string, search: Maybe<string>) => {
  if (isNilOrEmpty(domainName) || isNilOrEmpty(search)) {
    return false;
  }

  if (domainName === search) {
    return true;
  }

  /**
   * The only case that it will return if the strings are not equal is when domainName is a substring of search
   * and search includes the '.'(dot) like below:
   * - domainName: my-domain-name
   * - search: my-domain-name.com
   *
   */
  const escapedString = escapeRegExp(`${domainName}.`);
  const regexToCheck = new RegExp(`^${escapedString}`, 'i');

  if (search != null && regexToCheck.test(search)) {
    return true;
  }

  return false;
};

export const dispatchGAEventSearchMatchDomainName = (nameWithoutExtension: string, searchPhrase: Maybe<string>) => {
  const isDomainMatchSearchedText = domainNameMatchWithSearch(nameWithoutExtension, searchPhrase);

  let valueToSend = isDomainMatchSearchedText ? '1' : '0';

  if (searchPhrase == null) {
    valueToSend = 'Unknown';
  }

  const tealiumPayload: Record<string, string | number> = {
    action: 'click',
    category: 'Basket',
    label: 'Domain Exact Match',
    // eslint-disable-next-line camelcase
    domain_added_match_searched_text: valueToSend,
  };
  link(tealiumPayload);
};

export const dispatchGAEventDomainRanking = (domainIndex: number, fromHero: boolean = false) => {
  // all domains on the main hero result have position 1 and the first suggestion should have position 2
  const ranking = fromHero ? 1 : domainIndex + 2;

  link({
    category: 'Basket',
    action: 'click',
    label: 'Ranking',
    // eslint-disable-next-line camelcase
    domain_ranking: ranking,
  });
};
